module.exports = __webpack_public_path__ + "media/pl_pl_s4_Wojciech.0ddd432d.oga";